if (!customElements.get('countdown-timer')) {
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('shopify:section:load', (e) => {
      this.init();
    });
    this.init();
  }

  init () {
    // Destructure dataset properties
    const { date, time = '00:00', restart = 'false', repeatcycle = '' } = this.dataset;

    // Use array destructuring with default values to avoid NaN values
    const [day = 0, month = 0, year = 0] = date.split('-').map(Number);
    const [tarhour = 0, tarmin = 0] = time.split(':').map(Number);

    this.shouldRestart = restart.toLowerCase() === 'true';
    this.repeatCycle = repeatcycle;

    this.initializeDates(year, month, day, tarhour, tarmin);

    // Cache DOM elements
    this.elements = {
      days: this.querySelector('.days .countdown-timer__date-header'),
      hours: this.querySelector('.hours .countdown-timer__date-header'),
      minutes: this.querySelector('.minutes .countdown-timer__date-header'),
      seconds: this.querySelector('.seconds .countdown-timer__date-header'),
      loading: this.querySelector('.main-countdown-timer__loading')
    };

    // Initialize the timer interval
    this.interval = setInterval(() => this.updateTime(), 1000);
  }

  initializeDates(year, month, day, tarhour, tarmin) {
    const now = new Date();
    let startDate = new Date(year, month - 1, day, tarhour, tarmin);
    if (this.shouldRestart && startDate < now) {
      startDate = this.getNextOccurrence(startDate);
    }

    this.countDownDate = startDate.getTime();
  }

  getNextOccurrence(startDate) {
    const now = new Date();
    if (startDate < now) {
      if (this.repeatCycle === 'Week') {
        startDate.setDate(startDate.getDate() + 7);
      } else if (this.repeatCycle === 'Month') {
        startDate.setMonth(startDate.getMonth() + 1);
      }
    }

    return startDate;
  }

  updateTime() {
    const now = new Date().getTime();
    const distance = this.countDownDate - now;
    if (distance < 0) {
      if (this.shouldRestart) {
        this.initializeDates(...Object.values(this.extractDateParts()));
        setTimeout(() => this.updateTime(), 1000);
      } else {
        this.displayZero();
        clearInterval(this.interval);
      }
    } else {
      this.updateDisplay(distance);
    }
  }

  extractDateParts() {
    const startDate = new Date(this.countDownDate);
    return {
      year: startDate.getFullYear(),
      month: startDate.getMonth() + 1,
      day: startDate.getDate(),
      hour: startDate.getHours(),
      min: startDate.getMinutes(),
    };
  }

  updateDisplay(distance) {
    const times = {
      days: Math.floor(distance / (1000 * 60 * 60 * 24)),
      hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((distance % (1000 * 60)) / 1000),
    };

    Object.entries(times).forEach(([unit, value]) => {
      this.elements[unit].textContent = CountdownTimer.addZero(value);
    });

    if(this.elements.loading) {
      setTimeout(() => {
        this.elements.loading.style.display = 'none';
      }, 1000);
    }
  }

  displayZero() {
    ['days', 'hours', 'minutes', 'seconds'].forEach(unit => {
      this.elements[unit].textContent = '00';
    });

    if(this.elements.loading) {
      this.elements.loading.style.display = 'none';
    }
  }

  static addZero(x) {
    return (x < 10 && x >= 0) ? `0${x}` : x;
  }
}

customElements.define('countdown-timer', CountdownTimer);
}
